module.exports = __webpack_public_path__ + "img/7-3.f532a34a.png";